import { gql } from '@apollo/client';

export const ALL_USERS_FOR_SELECT_INPUT = gql`
  query AllUsersForSelectInput($input: UserFilterInput!) {
    users: allUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
